'use strict';

/** @type {import('./round')} */
module.exports = Math.round;



//////////////////
// WEBPACK FOOTER
// ./~/react-router/~/math-intrinsics/round.js
// module id = 5633
// module chunks = 0